'use client'
import { Printer, Share2 } from 'lucide-react'

const PrintShareBar = () => (
    <div className="bg-gradient-to-r from-[#00d69f]/5 to-[#00d69f]/5 px-6 py-3 border-b border-slate-200 flex items-center justify-end gap-3">
        <button
            onClick={() => window.print()}
            className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-[#00a87a] transition-colors"
        >
            <Printer size={12} /> Print
        </button>
        <button
            onClick={() => { navigator.clipboard.writeText(window.location.href); alert('Link copied!') }}
            className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-[#00a87a] transition-colors"
        >
            <Share2 size={12} /> Share
        </button>
    </div>
)

export default PrintShareBar
